<div>
  <div class="flex justify-between relative flex-col">
    <div class="bg-primary flex items-center justify-between px-1">
      <mat-tab-group
        (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="currentTab"
        class="users-tabs"
      >
        <mat-tab label="ACTIVE USERS"></mat-tab>
        <mat-tab label="ARCHIVED USERS"></mat-tab>
      </mat-tab-group>

      <button
        *ngIf="!isAdmin()"
        class="mr-2"
        mat-flat-button
        color="accent"
        (click)="navigateToAddUser()"
      >
        ADD USER +
      </button>
    </div>
  </div>

  <router-outlet></router-outlet>
</div>
